const filterItemsByOrder = (order, items) => {
    const filtered = {}

    order.map(itemId => {
        filtered[itemId] = items[itemId]
    })

    return filtered
}

export default filterItemsByOrder